import React, { useState } from 'react';
import s from '../../pages/PDV.module.css';

// Validador de NF-e/NFC-e da SEFAZ-RS: cola-se o XML e ele aponta campo a
// campo o que está fora do schema/regras de validação.
export const URL_VALIDADOR_SEFAZ_RS = 'https://www.sefaz.rs.gov.br/NFE/NFE-VAL.aspx';

async function copiarTexto(texto) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch { /* cai no fallback (http, permissão negada) */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = texto;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export function montarLogDiagnostico(d) {
  const partes = [
    ['Mensagem de erro', d.motivo || d.erro || '—'],
    ['HTTP Status SEFAZ', d.sefaz_status],
    ['Resposta da SEFAZ', d.sefaz_resposta],
    ['XML Gerado (antes da assinatura)', d.xml_gerado],
    ['XML Assinado (enviado à SEFAZ)', d.xml_assinado],
  ].filter(([, v]) => v != null && v !== '');
  return [`Diagnóstico ${String(d.tipo || '').toUpperCase()}`, ...partes.map(([t, v]) => `===== ${t} =====\n${v}`)].join('\n\n');
}

const btnPequeno = {
  marginLeft: 8, padding: '1px 8px', fontSize: 11, cursor: 'pointer', borderRadius: 4,
  border: '1px solid #94a3b8', background: '#fff', color: '#1e293b', textTransform: 'none', fontWeight: 500,
};

export default function ModalDiagnosticoNfce({ modalDiagnostico, setModalDiagnostico, dadosDiagnostico }) {
  const [copiado, setCopiado] = useState('');
  if (!modalDiagnostico || !dadosDiagnostico) return null;
  const d = dadosDiagnostico;

  const copiar = async (chave, texto) => {
    const ok = await copiarTexto(texto);
    setCopiado(ok ? chave : 'erro');
    setTimeout(() => setCopiado(''), 2500);
  };
  const rotulo = (chave, padrao) => (copiado === chave ? '✔ Copiado' : padrao);

  const xmlValidar = d.xml_assinado || d.xml_gerado || '';
  const abrirValidador = async () => {
    if (xmlValidar) await copiar('validador', xmlValidar);
    window.open(URL_VALIDADOR_SEFAZ_RS, '_blank', 'noopener');
  };

  const Secao = ({ titulo, valor, chave }) => (
    <section className={s.diagSecao}>
      <div className={s.diagTituloSecao}>
        {titulo}
        <button type="button" style={btnPequeno} onClick={() => copiar(chave, valor)}>{rotulo(chave, '📋 Copiar')}</button>
      </div>
      <pre className={s.diagPre}>{valor}</pre>
    </section>
  );

  return (
        <div className={s.modalOverlay} onClick={() => setModalDiagnostico(false)}>
          <div className={s.modalDiagnostico} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>🔍 Diagnóstico NFC-e — {d.tipo?.toUpperCase()}</span>
              <button className={s.modalClose} onClick={() => setModalDiagnostico(false)}>✕</button>
            </div>
            <div className={s.diagBody}>
              <Secao titulo="Mensagem de erro" chave="motivo" valor={d.motivo || d.erro || '—'} />
              {d.sefaz_status && <Secao titulo="HTTP Status SEFAZ" chave="status" valor={String(d.sefaz_status)} />}
              {d.sefaz_resposta && <Secao titulo="Resposta da SEFAZ" chave="resposta" valor={d.sefaz_resposta} />}
              {d.xml_gerado && <Secao titulo="XML Gerado (antes da assinatura)" chave="gerado" valor={d.xml_gerado} />}
              {d.xml_assinado && <Secao titulo="XML Assinado (enviado à SEFAZ)" chave="assinado" valor={d.xml_assinado} />}
            </div>
            <div className={s.modalFooter} style={{ justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                <button className={s.btnCancelarModal} onClick={() => copiar('log', montarLogDiagnostico(d))}>
                  {rotulo('log', '📋 Copiar log completo')}
                </button>
                <button className={s.btnCancelarModal} onClick={abrirValidador}
                  title="Copia o XML assinado e abre o validador da SEFAZ-RS — é só colar (Ctrl+V) no campo da página">
                  {rotulo('validador', '🌐 Abrir validador SEFAZ-RS')}
                </button>
                {copiado === 'validador' && <span style={{ fontSize: 12, color: '#16a34a' }}>XML copiado — cole (Ctrl+V) no validador</span>}
                {copiado === 'erro' && <span style={{ fontSize: 12, color: '#dc2626' }}>Não foi possível copiar — selecione o texto e use Ctrl+C</span>}
              </div>
              <button className={s.btnCancelarModal} onClick={() => setModalDiagnostico(false)}>Fechar</button>
            </div>
          </div>
        </div>
  );
}
